import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Avatar from "../assets/images/user.jpg";
import { Outlet } from "react-router-dom";
import { CustomerContext } from "./Context/CustomerContext";

const customerOption = [
  {
    name: `Đơn hàng`,
    slug: `order`,
  },
  {
    name: `Tài khoản`,
    slug: `edit-account`,
  },
  // {
  //   name: `Điểm của tôi`,
  //   slug: ``,
  // },
];

const Customer = () => {
  const navigate = useNavigate();
  const { customerData } = useContext(CustomerContext);
  const [data, setData] = useState(customerData);

  const clientToken = localStorage.getItem("client_token")
  useEffect(() => {
    if (!clientToken) {
      navigate(`/`);
    }
  }, []);

  useEffect(() => {
    setData(customerData);
  }, [customerData]);

  return (
    <>
      <div className="customer-container mt-4">
        <div className="login-signup-title"> Tài khoản </div>
        <div className="customer-layout">
          <div className="customer-left">
            <div className="customer-avatar">
              <img src={Avatar} alt="" />
              <p>{data.visibleName}</p>
              <span>#{data.id}</span>
            </div>
            <ul className="customer-menu">
              <Link to={``}>
                <li>Trang tài khoản</li>
              </Link>
              {customerOption.map((item, idx) => (
                <Link to={item.slug} key={idx}>
                  <li>{item.name}</li>
                </Link>
              ))}
              {/* <li style={{ cursor: "pointer" }} onClick={handleLogout}>
                Đăng xuất
              </li> */}
            </ul>
          </div>
          <div className="customer-right">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Customer;
